<div class="col-md-6 bitcoin-chart-block-second">
    <ul class="nav" role="tablist">
        <li class="nav-item" *ngFor="let interval of intervals" role="presentation">
            <button
                role="tab"
                type="button"
                (click)="changeInterval(interval)"
                class="nav-link btn btn-sm1 btn-interval"
                [attr.aria-label]="activeInterval"
                [ngClass]="{ active: interval === activeInterval }">
                {{ interval }}
            </button>
        </li>
    </ul>
</div>
